import { CustomWindow } from '@entities/CustomWindow';

declare let window: CustomWindow;

/**
 * Logger for Sentiments
 */
class LoggerService {
  constructor(public appName: string) {}

  /**
   * Handle logs
   * @param message
   * @param args
   */
  log(message: string, ...args: any) {
    if (window.wogaaCustom && window.wogaaCustom.log) {
      window.wogaaCustom.log(this.appName, message, ...args);
    }
  }
}

export const Logger = new LoggerService('Sentiments:Widget');
